module.exports = __webpack_public_path__ + "img/817-84af0a.png";